import {
    GET_ALL_PROJECT_NUMBER, GET_ALL_PROJECT_NUMBER_ERROR,
    GET_ALL_PO_DETAILS, GET_ALL_PO_DETAILS_ERROR, GET_ALL_SMS_DOCUMENTS, GET_ALL_SMS_DOCUMENTS_ERROR,
    GET_ALL_DETAILS_FOR_DISPATCH_SUPPLIER_DOCUMENTS, GET_ALL_DETAILS_FOR_DISPATCH_SUPPLIER_DOCUMENTS_ERROR,
} from '../type'
import axios from 'axios';
import env from '../../ENV';
let ROOT_URL = env.BACKEND_URL;


export const getAllProjectNumber = () => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}projects/all`);
        dispatch({
            type: GET_ALL_PROJECT_NUMBER,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_ALL_PROJECT_NUMBER_ERROR,
            payload: console.log(e),
        })
    }
}

export const getAllPODetails = (param) => async dispatch => {

    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}podetails/all`,
            data: param,
            headers: {
                'content-type': 'application/json',
            }
        })
        // swal("Requested has been saved",{icon:"success"})
        dispatch({
            type: GET_ALL_PO_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        console.log("Error", e.response);
        // let message = e && e.response && e.response.data && e.response.data.message ? e.response.data.message : "Something went wrong, please try again later"
        // swal(message,{icon:"error"});
        dispatch({
            type: GET_ALL_PO_DETAILS_ERROR,
            payload: console.log(e),
        })
    }

}



export const getAllPOItemDetails = (data) => async dispatch => {

    console.log("recieved in store ", data)
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}podetails/all`,
            data: data,
            //{
            //     "POSAPid": 1,
            //     "SearchTerm" : ""
            //     },
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_ALL_PO_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_ALL_PO_DETAILS_ERROR,
            payload: console.log(e),
        })
    }

}


// export const getAllSmsDocumentsOfDispatch = (data) => async dispatch => {
//     try{
//         const res = await axios.post(`${ROOT_URL}sms-documents-of-dispatch/all`);
//         dispatch( {
//             type: GET_ALL_SMS_DOCUMENTS,
//             payload: res.data,
//         })
//     }
//     catch(e){
//         dispatch( {
//             type: GET_ALL_SMS_DOCUMENTS_ERROR,
//             payload: console.log(e),
//         })
//     }
// }
export const getAllSmsDocumentsOfDispatch = (data) => async dispatch => {

    console.log("recieved in store ", data)
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}get-sms-documents-dispatch`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_ALL_SMS_DOCUMENTS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_ALL_SMS_DOCUMENTS_ERROR,
            payload: console.log(e),
        })
    }

}


export const getAllDetailsForSupplierDocumentsRegardingDispatch = (data) => async dispatch => {

    console.log("recieved!!", data)
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}getAllDetailsForSupplierDocumentsRegardingDispatch`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_ALL_DETAILS_FOR_DISPATCH_SUPPLIER_DOCUMENTS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_ALL_DETAILS_FOR_DISPATCH_SUPPLIER_DOCUMENTS_ERROR,
            payload: console.log(e),
        })
    }

}